var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AccountApi } from "../../core/api/accountApi";
import { SET_CONTEXT, CLEAR_CONTEXT, SET_CONTEXT_COMPANY, USER_LOGGED_OUT, COMPANY_CHANGED, SET_CONTEXT_APPLICATION, SET_SITE_STATUSES, SET_CONTEXT_TASK, SET_CONTEXT_SUB_CATEGORY, GROUP_CHANGED, USERS_CHANGED, HAS_PROFILE_PHOTO, PROFILE_PHOTO_URL, } from "./types";
import { SessionStorage } from "../../core/helpers/localStorage/sessionStorage";
import { SessionVariables } from "../../core/constants/SessionVariables";
import { loginRoute } from "../../core/constants/routesPath";
import isEmpty from "../../core/helpers/isEmpty";
export const setContext = (data) => ({
    type: SET_CONTEXT,
    payload: data,
});
export const setContextCompany = (data) => ({
    type: SET_CONTEXT_COMPANY,
    payload: data,
});
export const clearContext = () => ({
    type: CLEAR_CONTEXT,
});
export const handleError = () => ({
    type: CLEAR_CONTEXT,
});
export const logout = () => ({
    type: USER_LOGGED_OUT,
});
export const usersChanged = () => ({
    type: USERS_CHANGED,
});
export const companyChanged = () => ({
    type: COMPANY_CHANGED,
});
export const groupChanged = () => ({
    type: GROUP_CHANGED,
});
export const setContextApplication = (data) => ({
    type: SET_CONTEXT_APPLICATION,
    payload: data,
});
export const setContextTask = (data) => ({
    type: SET_CONTEXT_TASK,
    payload: data,
});
export const setContextSubCategory = (data) => ({
    type: SET_CONTEXT_SUB_CATEGORY,
    payload: data,
});
export const setSiteStatuses = (data) => {
    return {
        type: SET_SITE_STATUSES,
        payload: data,
    };
};
export const hasProfilePhoto = (has) => ({
    type: HAS_PROFILE_PHOTO,
    payload: has,
});
export const setProfilePhotoUrl = (url) => ({
    type: PROFILE_PHOTO_URL,
    payload: url,
});
export function signIn(user) {
    return function (dispatch) {
        return AccountApi.signIn(user)
            .then((response) => {
            if (response.jwt !== "") {
                SessionStorage.setKey(SessionVariables.AUTH_TOKEN, response.jwt);
            }
            return response;
        })
            .catch((error) => {
            throw error;
        });
    };
}
export function logoutActions(history) {
    return function (dispatch, getState) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { isAuthenticated } = (_a = getState()) === null || _a === void 0 ? void 0 : _a.context;
            const sessionContext = SessionStorage.getKey(SessionVariables.USER_CONTEXT);
            if (isAuthenticated && isEmpty(sessionContext)) {
                return dispatch(clearLogoutSession(history));
            }
            return AccountApi.logout().then((response) => {
                if ((response === null || response === void 0 ? void 0 : response.status) === 401 ||
                    (response === null || response === void 0 ? void 0 : response.status) === 403 ||
                    (response === null || response === void 0 ? void 0 : response.ok)) {
                    return dispatch(clearLogoutSession(history, true));
                }
            });
        });
    };
}
export function clearLogoutSession(history, selfLogoutAction = false) {
    return function (dispatch) {
        SessionStorage.clearStorage();
        dispatch(clearContext());
        history.replace(loginRoute, { action: "logout" });
        selfLogoutAction && dispatch(logout());
        return window.location.reload();
    };
}
export function loadContext() {
    return function (dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield AccountApi.loadContext();
                if (response) {
                    SessionStorage.setKey(SessionVariables.USER_CONTEXT, response);
                    dispatch(setContext(response));
                    if (response === null || response === void 0 ? void 0 : response.hasProfilePhoto) {
                        const url = yield AccountApi.getProfilePhotoUrlAutoRefresh(true);
                        dispatch(setProfilePhotoUrl(url));
                        dispatch(hasProfilePhoto(!!url));
                        const updatedContext = Object.assign(Object.assign({}, response), { hasProfilePhoto: !!url, profilePhotoUrl: url });
                        SessionStorage.setKey(SessionVariables.USER_CONTEXT, updatedContext);
                    }
                }
                return response;
            }
            catch (error) {
                throw error;
            }
        });
    };
}
export function uploadProfilePhoto(file) {
    return function (dispatch, getState) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield AccountApi.uploadProfilePhoto(file);
                const url = yield AccountApi.getProfilePhotoUrlAutoRefresh(true, undefined, true);
                dispatch(hasProfilePhoto(true));
                dispatch(setProfilePhotoUrl(url));
                const currentContext = (_a = getState()) === null || _a === void 0 ? void 0 : _a.context;
                const updatedContext = Object.assign(Object.assign({}, currentContext), { hasProfilePhoto: true, profilePhotoUrl: url });
                SessionStorage.setKey(SessionVariables.USER_CONTEXT, updatedContext);
                return true;
            }
            catch (e) {
                return false;
            }
        });
    };
}
export function fetchProfilePhotoUrl(force = false) {
    return function (dispatch, getState) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = yield AccountApi.getProfilePhotoUrlAutoRefresh(true, undefined, force);
                dispatch(setProfilePhotoUrl(url));
                dispatch(hasProfilePhoto(!!url));
                const currentContext = (_a = getState()) === null || _a === void 0 ? void 0 : _a.context;
                const updatedContext = Object.assign(Object.assign({}, currentContext), { hasProfilePhoto: !!url, profilePhotoUrl: url });
                SessionStorage.setKey(SessionVariables.USER_CONTEXT, updatedContext);
                return url;
            }
            catch (e) {
                return null;
            }
        });
    };
}
export function deleteProfilePhoto() {
    return function (dispatch, getState) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield AccountApi.deleteProfilePhoto();
                dispatch(hasProfilePhoto(false));
                dispatch(setProfilePhotoUrl(null));
                const currentContext = (_a = getState()) === null || _a === void 0 ? void 0 : _a.context;
                const updatedContext = Object.assign(Object.assign({}, currentContext), { hasProfilePhoto: false, profilePhotoUrl: null });
                SessionStorage.setKey(SessionVariables.USER_CONTEXT, updatedContext);
                return true;
            }
            catch (e) {
                return false;
            }
        });
    };
}
